import React from "react";
import "../style/BackToTopBtn.css";

const BackToTopBtn = (props) => {
  return (
    <button
      className="backToTopBtn"
      style={{ visibility: props?.visible ? props?.visible : "hidden" }}
      onClick={props.onClick}
    >
      &uarr;
    </button>
  );
};

export default BackToTopBtn;
